import uniqBy from 'lodash/uniqBy';
import noAvatar from '../assets/img/no-avatar.png';
import { toast } from 'react-toastify';

var isDebug = false;
var numbersAndCharsArray = [35, 42, 43, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
var numbersArray = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
var serviceAvailabilityCount = [];

/**
 * get query parameter from url
 * @param  {string} name
 * @param  {string} url
 * @return {string} query param value
 */
export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * strips all non numeric characters and returns number.
 * @param  {string} phone
 * @return {number} filtered phone number
 */
export function filterPhoneNumber(phone) {
  let phoneNumber = phone.replace(/ /g, '').replace(/[^+\d]/g, '');
  if (phoneNumber.substring(0, 1) == '+') {
    phoneNumber = phoneNumber.replace(/\D/g, '');
    const firstTwoChar = phoneNumber.substring(0, 2);
    if (firstTwoChar != '00') {
      phoneNumber = `00${phoneNumber}`;
    }
  }
  return phoneNumber;
}

export function callTimer(sec) {
  let hr = Math.floor(sec / 3600);
  let min = Math.floor((sec - (hr * 3600)) / 60);
  sec -= ((hr * 3600) + (min * 60));
  sec += ''; min += '';
  while (min.length < 2) { min = '0' + min; }
  while (sec.length < 2) { sec = '0' + sec; }
  hr = (hr) ? hr + ':' : '';
  return hr + min + ':' + sec;
}

export function filterUrl(url) {
  let url_filter = '';
  url = url.trim();
  if (url !== '') {
    url_filter = url.includes('http://') || url.includes('https://') ? url : `https://${url}`;
  }
  return url_filter;
}

export function imgError(e) {
  e.target.src = noAvatar;
}

export function getUniqueCalls(calls) {
  return uniqBy(calls, 'data.id').length;
}

export function toastErrorMsg(message, componentRef, varRef) {
  if (!toast.isActive(componentRef[varRef])) {
    componentRef[varRef] = toast.error(message, { autoClose: false });
  }
  else {
    toast.update(componentRef[varRef], { render: message, className: 'toast-animate' });
    setTimeout(() => {
      toast.update(componentRef[varRef], { render: message, className: 'toast-dummy' });
    }, 500);
  }
}

export const sortArrayByProperty = (arr, propName, isNumeric = false) => {
  arr.sort((a, b) => {
    let valA = isNumeric ? a[propName] : a[propName].toLowerCase();
    let valB = isNumeric ? b[propName] : b[propName].toLowerCase();

    if (valA < valB)
      return -1;
    if (valA > valB)
      return 1;
    return 0;
  });

  return arr;
}

export function setDebug(value) {
  isDebug = value;
}

export function getIsDebug() {
  return isDebug;
}

export function logData(msg, data = "") {
  if (isDebug) {
    if (data !== "") {
      // console.log(msg, data);
    }
    else {
      // console.log(msg);
    }
  }
}

export function keyDownHandler(event, validator) {
  const keyCode = event.which || event.keyCode;

  if (event.ctrlKey || event.metaKey) {
    return;
  }

  if (validator === "allowNumbersAndChars") {
    if (!(
      (keyCode >= 48 && keyCode <= 57 && !event.shiftKey) ||
      (keyCode >= 96 && keyCode <= 105) ||
      keyCode == 107 ||
      (keyCode == 187 && event.shiftKey) ||
      keyCode == 106 ||
      (keyCode == 56) ||
      keyCode == 8 ||
      keyCode == 51 ||
      keyCode == 46 ||
      (keyCode >= 35 && keyCode <= 40)
    )) {
      event.preventDefault();
    }
  } else if ("allowOnlyNumbers") {
    if (!(
      (keyCode >= 48 && keyCode <= 57 && !event.shiftKey) ||
      (keyCode >= 96 && keyCode <= 105) ||
      keyCode == 8 ||
      keyCode == 46 ||
      (keyCode >= 35 && keyCode <= 40)
    )) {
      event.preventDefault();
    }
  }
}

export function replaceAll(text, search, replacement) {
  return text.split(search).join(replacement)
}

export function pasteHandler(event, validator) {
  const validKeys = validator === 'allowOnlyNumbers' ? numbersArray : numbersAndCharsArray;
  let actualValue = event.clipboardData.getData('Text');
  for (let index = 0; index < actualValue.length; index++) {
    if (!validKeys.includes(actualValue.charCodeAt(index))) {
      actualValue = actualValue.substr(0, index) + '.' + actualValue.substr(index + 1);
    }
  }
  const valueToPaste = replaceAll(actualValue, ".", "");
  let element = event.target;
  if (element.selectionStart === 0 &&
    element.selectionEnd === element.value.length
  ) {
    element.value = valueToPaste
  } else {
    element.value = element.value.substr(0, element.selectionStart) + valueToPaste +
      element.value.substr(element.selectionEnd, element.value.length);
  }
  event.preventDefault();
  
  return element;
}

export function setServiceAvailabilityCount(service, availabilityCount, unavailabilityCount) {
  serviceAvailabilityCount[service.id] = {};
  serviceAvailabilityCount[service.id].availabilityCount = availabilityCount;
  serviceAvailabilityCount[service.id].unavailabilityCount = unavailabilityCount;
}

export function getServiceAvailabilityCount(serviceId) {
  return (serviceAvailabilityCount && serviceAvailabilityCount[serviceId] && serviceAvailabilityCount[serviceId].availabilityCount);
}

export function getServiceUnavailabilityCount(serviceId) {
  return (serviceAvailabilityCount && serviceAvailabilityCount[serviceId] && serviceAvailabilityCount[serviceId].unavailabilityCount);
}

export function getWebPhoneDomain() {
  const websiteUrl = window.location.href;
  // const protocol = window.location.protocol;
  const protocol = 'https:';

  let domain = '';
  if (websiteUrl.includes("staging.invoxcontact.io")) {
    domain = protocol + '//staging.invoxcontact.io/22/webphonego/';

  }else if (websiteUrl.includes("go.invoxcontact.io")) {
    domain = protocol + '//go.invoxcontact.io/22/webphonego/';

  } else if(websiteUrl.includes("test.invoxcontact.io")) {
    domain = protocol + '//test.invoxcontact.io/22/webphonego/';
    
  } else {
    domain = 'http://localhost:3001'
  }
  return domain;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js